import {
  getValutes,
  getValute,
  getValuteCategories,
  getValuteForms,
  getTradePairs
} from "@/api";
//
export default {
  namespaced: true,
  //
  state: {
    valutes: [],
    categories: [],
    //
    activeValutes: {
      give: false,
      get: false
    },
    activeForms: {
      give: {},
      get: {}
    },
    isExchange: false,

    resultValutes: {
      give: false,
      get: false
    },

    resultForms: {
      give: false,
      get: false
    },
    tradePairs: []
  },
  mutations: {
    setValutes(state, valutes) {
      state.valutes = valutes;
    },
    setExchange(state, value) {
      state.isExchange = value;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },

    setActiveValute(state, { type, valute }) {
      state.activeValutes[type] = valute;
    },

    addActiveForms(state, { id, type, forms }) {
      state.activeForms[type === "output" ? "get" : type][id] = forms;
    },

    setResultValutes(state, { type, valute }) {
      state.resultValutes[type] = valute;
    },

    setResultForms(state, { type, forms }) {
      state.resultForms[type] = forms;
    },
    setTradePairs(state, tradePairs) {
      state.tradePairs = tradePairs;
    }
  },
  //
  actions: {
    getValutes(store) {
      return getValutes().then(response => {
        store.commit("setValutes", response.data.result);
        //
        return response;
      });
    },

    getValute(store, { type, id }) {
      return getValute(id).then(response => {
        store.commit("setActiveValute", { type, valute: response.data.result });
        //
        return response;
      });
    },
    setIsExchange({ commit }, value) {
      commit("setExchange", value);
    },

    getValuteCategories(store) {
      return getValuteCategories().then(response => {
        store.commit("setCategories", response.data.result);
        //
        return response;
      });
    },

    async getValuteForms(store, { type, id, step }) {
      return await getValuteForms(id, type, step).then(response => {
        store.commit("addActiveForms", {
          id,
          type,
          forms: response.data.result
        });
        //
        return response;
      });
    },
    getTradePairs(store) {
      return getTradePairs().then(response => {
        const tradePairs = response.data;
        //
        store.commit("setTradePairs", tradePairs);
        //
        return response;
      });
    }
  },
  getters: {
    valutesGetter(state) {
      if (state.valutes == null) return null;
      return state.valutes;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/valutes.js